export enum StatType {
  Views = 'views',
  Orders = 'orders',
}

export enum StatSubType {
  None = '-',
  Seat = 'seat',
  TakeAway = 'away',
  Delivery = 'delivery',
}
